/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-07-04 10:31:47
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2024-07-05 09:55:56
 * @FilePath: \qcloud-web-pc-4.0\src\locale\lang\cn.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import login from '../../views/Login/lang/cn';
import home from '@/views/home/lang/cn';
import header from '@/components/page-header/lang/cn';
import footer from '@/components/page-footer/lang/cn';
// import computing from '@/views/computing/lang/cn';

import paginateCommon from '@/components/pagination-common/lang/cn';
import documentTitle from '@/router/lang/cn';
import errorBoundary from '@/components/error-boundary/lang/cn';
// import page_footer from '@/views/footer/lang/cn';
const zhCN = {
  login,
  
  home,
  header,
  footer,
  errorBoundary,
  documentTitle,
  paginateCommon,
  // page_footer
};
export default zhCN;
